<template>
  <div class="right_col" role="main">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>
            {{ title }}
            <span v-if="isConfirmView"
              >- {{ $t('orderPage.inputConfirmation') }}</span
            >
          </h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <div class="x_content form-horizontal form-label-left">
              <alert
                :title="title"
                :success-message="$t('common.isSuccess')"
                :error-message="$t('common.isFailure')"
                :alerts="alerts"
                :errors="errors"
                :display="alertDisplay"
                @closeAlert="closeAlert"
              />

              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="name"
                >
                  {{ $t('common.eventName') }}： <span class="required">*</span>
                </label>
                <div class="col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="name"
                    v-model="name"
                    v-validate="ValidRules.name"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.eventName')"
                    :placeholder="$t('common.eventName')"
                    type="text"
                    name="name"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('name')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('name')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12">
                  {{ $t('eventInformationPage.postingTerm') }}：
                  <span class="required">*</span>
                </label>
                <div class="col-md-5 col-sm-5 col-xs-12">
                  <label for="startAt" class="control-label"
                    >{{ $t('eventInformationPage.startDate') }}：</label
                  >
                  <input
                    id="startAt"
                    ref="startAt"
                    v-model="eventStartAt"
                    v-validate="ValidRules.startAt"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('eventInformationPage.postingTermStart')"
                    type="date"
                    name="startAt"
                    style="font-weight: 700"
                  />
                  <label
                    style="margin-left: 10px"
                    for="endAt"
                    class="control-label"
                    >{{ $t('eventInformationPage.endDate') }}：</label
                  >
                  <input
                    id="endAt"
                    ref="endAt"
                    v-model="eventEndAt"
                    v-validate="ValidRules.endAt"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('eventInformationPage.postingTermEnd')"
                    type="date"
                    name="endAt"
                    style="font-weight: 700"
                  />
                  <div
                    v-show="validator.has('startAt') || validator.has('endAt')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('startAt')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('endAt')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12">
                  {{ $t('eventInformationPage.decisionTiming') }}：
                  <span class="required">*</span>
                </label>
                <div
                  class="form-group col-md-5 col-sm-5 col-xs-12 select-radio"
                >
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="timing1"
                      v-model="timing"
                      v-validate="ValidRules.timing"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('eventInformationPage.decisionTiming')"
                      type="radio"
                      name="timing"
                      value="1"
                      class="flat"
                    />
                    <label
                      class="control-label"
                      for="timing1"
                      style="margin-left: 3px"
                      >{{
                        $t('eventInformationPage.whenSeatAuthentication')
                      }}</label
                    >
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="timing2"
                      v-model="timing"
                      :disabled="isConfirmView"
                      type="radio"
                      name="timing"
                      value="2"
                      class="flat"
                    />
                    <label
                      class="control-label"
                      for="timing2"
                      style="margin-left: 3px"
                      >{{ $t('eventInformationPage.whenOrder') }}</label
                    >
                  </div>
                  <div
                    v-show="validator.has('timing')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('timing')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12">
                  {{ $t('eventInformationPage.eventConditions') }}：
                </label>
                <div class="col-md-5 col-sm-9 col-xs-12">
                  <label class="control-label" for="birthMonth"
                    >{{ $t('eventInformationPage.birthMonth') }}：</label
                  >
                  <input
                    id="birthMonth"
                    v-model="birthMonth"
                    :disabled="isConfirmView"
                    type="checkbox"
                    name="birthMonth"
                    value="1"
                    class="flat"
                  />
                  <label for="birthMonth" class="control-label description">{{
                    $t('eventInformationPage.visitInBirthMonth')
                  }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12">
                  {{
                    $t('eventInformationPage.operationAtConditionCoincidence')
                  }}：
                  <span class="required">*</span>
                </label>
                <div
                  class="form-group col-md-5 col-sm-5 col-xs-12 select-radio"
                >
                  <div class="col-md-4 col-sm-12 col-xs-12">
                    <input
                      id="action1"
                      ref="action"
                      v-model="action"
                      v-validate="ValidRules.action"
                      :disabled="isConfirmView"
                      :data-vv-as="
                        $t(
                          'eventInformationPage.operationAtConditionCoincidence'
                        )
                      "
                      type="radio"
                      name="action"
                      value="1"
                      class="flat"
                    />
                    <label for="action1" class="control-label">{{
                      $t('eventInformationPage.gachadamaEmission')
                    }}</label>
                  </div>
                  <div class="col-md-4 col-sm-12 col-xs-12">
                    <input
                      id="action2"
                      ref="action"
                      v-model="action"
                      :disabled="isConfirmView"
                      type="radio"
                      name="action"
                      value="2"
                      class="flat"
                    />
                    <label for="action2" class="control-label">{{
                      $t('eventInformationPage.bikkuraponLottery')
                    }}</label>
                  </div>
                  <div class="col-md-4 col-sm-12 col-xs-12">
                    <input
                      id="action3"
                      ref="action"
                      v-model="action"
                      :disabled="isConfirmView"
                      type="radio"
                      name="action"
                      value="3"
                      class="flat"
                    />
                    <label for="action3" class="control-label">{{
                      $t('eventInformationPage.optionalVideo')
                    }}</label>
                  </div>
                  <div class="clearfix"></div>
                  <div
                    v-show="validator.has('action')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('action')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="action == 3" class="form-group">
                <div class="col-md-offset-3 col-md-5 col-sm-5 col-xs-12">
                  <input
                    v-model="movieFileName"
                    v-validate="ValidRules.movieFileName"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('eventInformationPage.videoName')"
                    :placeholder="$t('eventInformationPage.videoName')"
                    type="text"
                    name="movieFileName"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('movieFileName')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'movieFileName'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="shops"
                  >{{ $t('common.implementationGroup') }}：
                  <span class="required">*</span></label
                >
                <div class="col-md-5 col-sm-8 col-xs-11">
                  <textarea
                    id="shops"
                    v-model="inputShopValues"
                    v-validate="ValidRules.shops"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.implementationGroup')"
                    name="shops"
                    class="form-control"
                    rows="7"
                    readonly
                  ></textarea>
                  <div
                    v-show="validator.has('shops')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('shops')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-4 col-sm-1 col-xs-1">
                  <button
                    id="shops-btn"
                    :disabled="isConfirmView"
                    @click="showModal"
                    class="btn btn-success"
                  >
                    {{ $t('common.edit') }}
                  </button>
                </div>
              </div>
              <div class="ln_solid"></div>
              <div class="form-group">
                <div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                  <button @click="back" class="btn btn-default">
                    {{ $t('common.back') }}
                  </button>
                  <button
                    v-if="isConfirmView"
                    @click="submit"
                    class="btn btn-success"
                  >
                    {{ $t('orderPage.registration') }}
                  </button>
                  <button v-else @click="confirm" class="btn btn-success">
                    {{ $t('common.inputComplete') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      v-if="isShowModal"
      :current="'shop'"
      :list-items="allGroupDatas"
      @close="isShowModal = false"
      @valueInput="valueInput"
    />
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import Modal from '@/components/common/modal/AdRegistModal'
import EventRequest from '@/http/EventRequest'
import alert from '@/mixin/alert'
import ValidRules from '@/validator/EventRules'
import { mapGetters } from 'vuex'
export default {
  components: {
    Alert,
    Modal,
  },
  mixins: [alert],
  data() {
    return {
      title: this.$t('eventInformationPage.eventRegistration'),
      name: '',
      timing: null,
      birthMonth: true,
      groupList: [],
      action: null,
      movieFileName: '',
      eventStartAt: '',
      eventEndAt: '',
      inputShopValues: '',
      isEdit: false,
      isConfirmView: false,
      isShowModal: false,
      ValidRules: ValidRules,
    }
  },
  computed: {
    ...mapGetters({
      getEventById: 'event/getEventById',
      getGroups: 'shop/getGroupToShops',
    }),
  },
  mounted() {
    this.createGroupData()

    if (this.$route.name === 'eventFormEdit') {
      this.getStoreData(this.$route.params.id)
      this.isEdit = true
      this.title = this.$t('eventInformationPage.editEvent')
    }
  },
  methods: {
    // 実施グループの作成
    createGroupData: function() {
      const data = this.getGroups
      this.allGroupDatas = data.map((item) => {
        const names = item.shops.map((shop) => {
          return shop.name
        })
        const body = names.join('　')
        return [
          {
            type: 'checkbox',
            id: item.groupId,
            checked: false,
            target: 'shop',
          },
          item.groupId,
          { type: 'accordion', id: item.groupId, title: item.name, body: body },
        ]
      })
    },
    valueInput: function(inputValues) {
      this.inputShopValues = inputValues.join('\n')
      this.isShowModal = false
    },
    showModal: function() {
      this.isShowModal = true
    },
    getStoreData: function(id) {
      const store = this.getEventById(id)

      // 実施グループ
      let groupNameList = []
      store.groupList.forEach((item) => {
        const index = this.allGroupDatas.findIndex(
          (group) => group[1] === item.groupId
        )
        if (index > -1) {
          this.allGroupDatas[index][0].checked = true
          groupNameList.push(item.name)
        }
      })
      this.inputShopValues = groupNameList.join('\n')

      this.eventId = store.eventId
      this.name = store.name
      this.timing = store.timing
      this.birthMonth = store.birthMonth
      this.action = store.action
      this.movieFileName = store.movieFileName
      this.eventStartAt = global.moment(store.eventStartAt).format('YYYY-MM-DD')
      this.eventEndAt = global.moment(store.eventEndAt).format('YYYY-MM-DD')
    },
    back: function() {
      if (this.isConfirmView) {
        this.isConfirmView = false
      } else {
        this.$router.push({ name: 'event' })
      }
    },
    confirm: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isConfirmView = true
        }
      })
    },
    submit: function() {
      let groupIds = []
      this.allGroupDatas.forEach((item) => {
        if (item[0].checked) {
          groupIds.push(item[1])
        }
      })

      const request = new EventRequest()
      const params = {
        name: this.name,
        timing: Number(this.timing),
        birthMonth: Number(this.birthMonth),
        groupIds: groupIds,
        action: Number(this.action),
        eventStartAt: global
          .moment(this.eventStartAt)
          .format('YYYY-MM-DD 00:00:00'),
        eventEndAt: global
          .moment(this.eventEndAt)
          .format('YYYY-MM-DD 23:59:59'),
      }
      if (params.action === 3) {
        params['movieFileName'] = this.movieFileName
      }

      if (this.isEdit) {
        // 更新
        request
          .update(this.eventId, params)
          .then(() => {
            this.$router.push({
              name: 'event',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      } else {
        // 新規登録
        request
          .insert(params)
          .then(() => {
            this.$router.push({
              name: 'event',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      }
    },
  },
}
</script>
<style scoped>
.description {
  font-weight: normal;
  display: inline-block;
  margin-left: 5px;
}

div.select-radio label {
  margin-left: 3px;
}

div.select-radio div {
  padding-left: 0;
}
</style>
